import React, {useEffect, useState} from "react";
import DashboardLayout from "../../../layouts/Dashboard";

import DictionaryCRUDTable from "../../../components/CRUD/Tables/DictionaryCRUDTable";

const ReferralOrderTypeList = () => {    
    return (
        <DashboardLayout>
            <DictionaryCRUDTable
                entityType="referralOrderType"
                hasCode={true}
                hasDescription={true}
            />
        </DashboardLayout>
    )
};

export default ReferralOrderTypeList;
